<template>
  <div>
    <van-nav-bar
      :title="$t('app.nickname.title')"
      :left-text="$t('app.common.back')"
      left-arrow
      @click-left="$router.push('/member/information')"
    />
    <van-form @submit="onSubmit">
      <van-field
        v-model="nickName"
        name="nickName"
        :label="$t('app.nickname.nick_name')"
        :placeholder="$t('app.nickname.nick_name')"
        :rules="[{ required: true, message: this.$t('app.nickname.enter_nick_name') }]"
      />
      <div style="margin: 16px;">
        <van-button round block type="danger" size="small" native-type="submit">
          {{$t('app.common.sure')}}
        </van-button>
      </div>
    </van-form>


  </div>
</template>

<script>
    export default {
      name: "nickName",
      data(){
        return{
          nickName:''
        }
      },
      methods:{
        isLogin(){
          let that = this;
          if (!that.$store.state.loginType){
            that.$router.push('/login')
          }
        },
        onSubmit(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "modify_name",
                token: sessionStorage.getItem("token"),
                name: that.nickName
              }
            })
            .then(function(res) {
              let resData = res.data;
              if (res.data.code == 1) {
                that.$toast.success({
                  message: that.$t(resData.msg),
                  onClose:function () {
                    that.$router.push('/member/information')
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(that.$t(resData.msg));
              }
            });
        },
      },
      mounted:function () {
        let that = this;
        that.isLogin();
        if (!that.$store.state.loginType){
          that.$router.push('/login')
        }
      }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/NickName.vue